const fontSizes = {
  lg: '18px',
  md: '16px',
  sm: '14px',
};

export default fontSizes;
